import { AppColors } from "@/styles/colors";
import { Button, Flex, Text } from "@chakra-ui/react";
import { MessagesSquare } from "lucide-react";
import { NegotiationChatMessage } from "./NegotiationChatMessageList";
import { getLastMessage, toLocal } from "./chat-message-utils";

interface Props {
  title: string;
  messages: NegotiationChatMessage[];
  onOpenChat: () => void;
  testId?: string;
}

const titleFontSize = {
  "@media (max-width: 1350px) and (min-width: 1272px)": {
    fontSize: "12px",
  },
  "@media (max-width: 1414px) and (min-width: 1351px)": {
    fontSize: "14px",
  },
  "@media (max-width: 1590px) and (min-width: 1415px)": {
    fontSize: "16px",
  },
  "@media (max-width: 1696px) and (min-width: 1591px)": {
    fontSize: "18px",
  },
  "@media (max-width: 1900px) and (min-width: 1697px)": {
    fontSize: "20px",
  },
};

export const NegotiationLastMessage = ({
  title,
  messages,
  onOpenChat,
  testId = "negotiation-open-chat",
}: Props) => {
  const lastMessage = getLastMessage(messages);

  // Con un solo mensaje (el inicial, en estado "En proceso") todavía no hay
  // charla: se muestra como "Detalle" y no se ofrece entrar al chat. Recién
  // con más de un mensaje (la comunicación avanzó) vuelve a "Último mensaje"
  // y aparece el botón.
  const hasConversation = (messages ?? []).length > 1;
  const displayTitle =
    lastMessage && !hasConversation
      ? title.replace("Último mensaje", "Detalle")
      : title;

  return (
    <Flex
      flexDir="column"
      gap="12px"
      padding="12px"
      borderRadius="12px"
      border={`1px solid ${AppColors.WHITE_BORDER_1}`}
    >
      <Flex alignItems="center" justifyContent="space-between" gap="12px">
        <Text fontWeight={700} css={titleFontSize}>
          {displayTitle}
        </Text>

        {lastMessage && hasConversation && (
          <Button
            backgroundColor={AppColors.BLACK_BUTTON}
            paddingX="12px"
            variant="outline"
            onClick={onOpenChat}
            data-testid={testId}
          >
            <MessagesSquare size={16} color={AppColors.WHITE_SECONDARY} />
            <Text
              color={AppColors.WHITE_SECONDARY}
              fontWeight={400}
              fontSize="14px"
              marginLeft="4px"
            >
              Ingresar al chat
            </Text>
          </Button>
        )}
      </Flex>

      {lastMessage ? (
        <Flex flexDir="column" gap="4px">
          <Text fontWeight={400} fontSize="14px">
            {lastMessage.texto}
          </Text>
          <Text fontWeight={400} fontSize="12px" color={AppColors.GRAY_TEXT}>
            {toLocal(lastMessage.fechaHora).format("DD/MM/YYYY - HH:mm")}{" "}
            - {lastMessage.usuario}
          </Text>
        </Flex>
      ) : (
        <Text fontWeight={600} color={AppColors.GRAY_TEXT}>
          No hay mensajes para mostrar
        </Text>
      )}
    </Flex>
  );
};
